import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { useIntl } from "react-intl";
import PropTypes from "prop-types";

import * as ApplicationsUtils from "../../Utils/ApplicationsUtils";
import * as ApplicationConstant from "../../Constants/ApplicationConstant";

import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import LogService from "../../../middleware/CommonSdk/LogService";

const LOG_TAG = "APPLICATION_SEARCHBAR";

const ApplicationSearchBar = (props) => {
    const [searchValue, setSearchValue] = useState("");
    const intl = useIntl();

    useEffect(() => {
        LogService.trace(LOG_TAG, "useEffect location");
        if (ApplicationsUtils.isApplicationsPath(props.location) || ApplicationsUtils.isSandBoxPath(props.location)) {
            const newValue = ApplicationsUtils.getApplicationSearchValue(props.location);
            setSearchValue(newValue);
            if (props.onSearch) {
                LogService.debug(LOG_TAG, "useEffect location search:", newValue);
                props.onSearch(newValue);
            }

            const filterValue = ApplicationsUtils.getApplicationFilterValue(props.location, props.defaultFilter);
            if (props.onFilter) {
                LogService.debug(LOG_TAG, "useEffect location filter:", filterValue);
                props.onFilter(filterValue);
            }
        }
    }, [props.location]);

    useEffect(() => {
        LogService.debug(LOG_TAG, "useEffect reTriggerSearch", props.reTriggerSearch);
        if (props.onSearch && props.reTriggerSearch) {
            props.onSearch(searchValue);
        }
    }, [props.reTriggerSearch]);

    const handleSearchChange = (event) => {
        LogService.debug(LOG_TAG, "Search handleSearchChange", event.target.value);
        const searchValue = event.target.value;
        setSearchValue(searchValue);

        const action = () => {
            LogService.debug(LOG_TAG, "Search handleSearchChange in action");
            const newUrlPart = ApplicationsUtils.setApplicationSearchValueUrl(props.location, searchValue);
            props.history.push(props.location.pathname + newUrlPart);
        }
        ApplicationsUtils.debounce(action, ApplicationConstant.SEARCH_START_TIME);
    };
    const handleClearSearch = (event) => {
        LogService.trace(LOG_TAG, "handleClearSearch");
        const newUrlPart = ApplicationsUtils.setApplicationSearchValueUrl(props.location, "");
        props.history.push(props.location.pathname + newUrlPart);
    };

    const handleFilterChange = (event) => {
        LogService.trace(LOG_TAG, "handleFilterChange");
        const newUrlPart = ApplicationsUtils.setApplicationFilterValueUrl(props.location, event.target.value);
        props.history.push(props.location.pathname + newUrlPart);
    };

    LogService.trace(LOG_TAG, "Search render");

    let filterOptions = Object.values(ApplicationsUtils.applicationsFilters(intl)).map((filterItem) => {
        return <option key={filterItem.value} value={filterItem.value} >{filterItem.label}</option>
    });

    let filterValue = ApplicationsUtils.getApplicationFilterValue(props.location, props.defaultFilter);
    return (
        <div className="form-group d-flex w-100 mr-3">
            <div className="w-100 mr-3">
                <label className="input-label">{intl.messages.search}</label>
                <div className="input-group">
                    <input
                        type="text"
                        className="form-control"
                        aria-label="Search in list of applications"
                        placeholder={intl.messages.applicationSearchPlaceholder}
                        value={searchValue}
                        onChange={handleSearchChange}
                    />
                    <div className="input-group-append">
                        <button className="btn input-btn" type="button" onClick={handleClearSearch}>
                            <FontAwesomeIcon icon={faTimes} />
                        </button>
                    </div>
                </div>
            </div>

            {props.showFilter &&
                <div style={{ minWidth: 250 }}>
                    <label className="input-label">{intl.messages.filter}</label>
                    <select name="state" className="form-control" onChange={handleFilterChange} value={filterValue}>{filterOptions}</select>
                </div>
            }
        </div>
    );
};

ApplicationSearchBar.defaultProps = {
    reTriggerSearch: false,
    onSearch: null,
    onFilter: null,
    showFilter: true,
    defaultFilter: ApplicationsUtils.applicationsFilters().My.value
};

ApplicationSearchBar.propTypes = {
    reTriggerSearch: PropTypes.bool,
    onSearch: PropTypes.func,
    onFilter: PropTypes.func,
    showFilter: PropTypes.bool,
    defaultFilter: PropTypes.oneOf(Object.values(ApplicationsUtils.applicationsFilters()).map(item => item.value)),
};

export default withRouter(ApplicationSearchBar);